export default __webpack_public_path__ + "static/media/user-circle.e3b02f18.svg";